<template>
  <aside :show.sync="show" placement="right" header="修改团队集合信息" :width="400">
    <form>
      <h4 class="text-center">【{{trip.catalog}}】{{trip.heading}}</h4>
      <div class="form-group">
        <label class="control-label">日期</label>
        <input type="date" class="form-control" v-model="trip.start">
      </div>
      <div class="form-group">
        <label class="control-label">截止报名时间</label>
        <input type="text" class="form-control" data-field="datetime" v-model="trip.stopTime" >
      </div>
      <div class="form-group">
        <label class="control-label">集合时间</label>
        <input type="time" class="form-control" v-model="trip.assembleTime">
      </div>
      <div class="form-group">
        <label class="control-label">时间段</label>
        <input type="text" class="form-control" v-model="trip.assemblePeriod" placeholder="请填写">
      </div>
      <div class="form-group">
        <label class="control-label">集合地点</label>
        <input type="text" class="form-control" v-model="trip.assemblePlace">
      </div>
      <div class="form-group">
        <label class="control-label">显示状态</label>
        <select class="form-control" v-model="trip.hide">
          <option v-for="(key, val) in tripVisableStatus" track-by="$index" :value="key">{{val}}</option>
        </select>
      </div>
      <div class="form-group">
        <label class="control-label">带队人员</label>
        <select class="form-control" v-model="trip.leaderRole">
          <option value="GIVER">领队</option>
          <option value="ST_VOLUNTEER">ST志愿者</option>
          <option value="CE_VOLUNTEER">CE志愿者</option>
        </select>
      </div>
      <div class="from-group text-center">
        <button class="btn btn-primary" type="button" @click="click(submit)($event)">提交</button>
      </div>
    </form>
  </aside>
</template>

<script>
  import { aside } from 'vue-strap'
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import { pick } from 'lodash'

  export default {
    components: {
      aside
    },
    props: {
      trip: {
        required: true,
        type: Object
      },
      show: {
        required: true,
        twoWay: true
      }
    },
    data () {
      return {
        tripVisableStatus: config.tripVisableStatus
      }
    },
    methods: {
      submit () {
        let data = pick(this.trip, [
          'assembleTime',
          'assemblePlace',
          'assemblePeriod',
          'stopTime',
          'start',
          'hide',
          'leaderRole'
        ])
        return this.$http.put(`${config.apiWe}/product/trip/${this.trip.id}`, data)
          .then(() => {
            this.show = false
            this.$dispatch('callback')
          })
      },
      click: utils.click
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** Edit.vue?9e9ae99a
 **/